import React, { forwardRef } from 'react';
import './Textarea.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

const Textarea = forwardRef(({
  invalid = false,
  error = '',
  showCount = false,
  maxLength,
  value,
  defaultValue,
  className = '',
  textareaClassName = '',
  disabled,
  ...props
}, ref) => {
  const textValue = value ?? defaultValue ?? '';
  const count = String(textValue).length;
  const hasError = Boolean(error) || invalid;
  const showCountFooter = showCount || maxLength;

  return (
    <div className="reops-textarea-field">
      <span
        className={cx(
          'reops-textarea',
          hasError && 'is-invalid',
          disabled && 'is-disabled',
          className,
        )}
      >
        <textarea
          ref={ref}
          className={cx('reops-textarea__control', textareaClassName)}
          maxLength={maxLength}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          aria-invalid={hasError || undefined}
          {...props}
        />
        {showCountFooter ? (
          <div className="reops-textarea__footer">
            <span className="reops-textarea__count">
              {count}/{maxLength ?? 100}
            </span>
          </div>
        ) : null}
      </span>
      {error ? (
        <span className="reops-textarea-field__error" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
